export default __webpack_public_path__ + "static/media/cream-wavax.c2fa98ec.png";